import { useState } from "react";

import { truckService } from "@/services";
import { transformToOption } from "@/utils/transformToOption";

export function useTruck() {
  const [brands, setBrands] = useState({ data: [{ value: "", label: "" }], isLoading: false, isError: false });
  const [models, setModels] = useState({ data: [{ value: "", label: "" }], isLoading: false, isError: false });

  function fetchOptions<T extends "brands" | "models">(
    type: T,
    brandId?: T extends "models" ? string : undefined,
    options?: { onInit?: () => void; onSuccess?: <T>(data: T) => void; onError?: (error?: unknown) => void; onFinally?: () => void }
  ) {
    const matcher = {
      brands: async () => {
        options?.onInit?.();

        setBrands((prev) => ({ ...prev, isLoading: true }));
        const [error, data] = await truckService.query.getBrands();
        const formattedArr = transformToOption(
          data!,
          (item) => item.id,
          (item) => item.name
        );

        if (error) {
          options?.onError?.();
        }

        if (data) {
          options?.onSuccess?.(data);
        }

        setBrands((prev) => ({ ...prev, data: formattedArr, isLoading: false, isError: error }));
      },
      models: async () => {
        if (!brandId) return console.error("Brand ID is required to fetch models");
        setModels((prev) => ({ ...prev, isLoading: true }));
        const [error, data] = await truckService.query.getModelsByBrand(brandId);
        const formattedArr = transformToOption(
          data!,
          (item) => item.id,
          (item) => item.name
        );

        if (error) {
          options?.onError?.();
        }

        if (data) {
          options?.onSuccess?.(data);
        }

        setModels((prev) => ({ ...prev, data: formattedArr, isLoading: false, isError: error }));
      }
    };

    if (!(type in matcher)) return console.error(`Invalid type: ${type}. Expected ${Object.keys(matcher).join(", ")}.`);

    matcher[type]();
  }

  return {
    brands,
    models,
    fetchOptions
  };
}
